<div class="snackbar-container">
    <div class="toast-header">
        <strong>{{ data.title }}</strong>
        <button class="close-btn" (click)="closeToast()">✖</button>
    </div>
    <p>{{ data.message }}</p>
</div>